<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose, onMounted } from "vue";
import { useRouter } from 'vue-router'
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";

const router = useRouter();

const baseModal = ref(null);
const resolvePromise = ref(null);
const emit = defineEmits(['confirm']);

const modalContent = ref([])
const okButtonText = ref("확인");

const loaded = ref(false)
const content = ref(null);


const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = () => {
  baseModal.value.close();
  emit('confirm', true);
  if (resolvePromise) {
    resolvePromise.value(true); // 모달 확인 클릭 시 Promise를 resolve
  }
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

defineExpose({
  show,
})
</script>
<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner">
      <div class="modal-body">
        <p><b class="red">'회사 이력서 양식' 입사지원 방식입니다.</b></p>
        <p>
          채용공고에서 회사의 이력서 양식을<br/>
          다운로드 받아 작성하신 후 지원 바랍니다.
        </p>
      </div>
      <div class="modal-footer">
        <KSAPrimaryButton text="확인" @click="cancel" />
        <KSAPrimaryButton text="지원 계속하기" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  .close {
    top: -20px !important;
    right: -10px !important;;
  }
  .modal-body {
    p {
      margin-bottom: 0;
    }
  }
  .modal-footer {
    display: block;
    justify-content: center !important;
    gap: 10px;
    //button {
    //  width: 140px;
    //}
  }
}
</style>